let IdNamePair = require('./IdNamePair');

module.exports = class Imprint extends IdNamePair {};
